function removeElement(e) {e.parentNode.removeChild(e)}
export default removeElement;